var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mode=Light, Style=Line, State=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.59093 7.59093 4 12 4C16.4091 4 20 7.59093 20 12C20 16.4099 16.4092 20 12 20C7.59082 20 4 16.4099 4 12ZM12 2C6.48636 2 2 6.48636 2 12C2 17.5145 6.48636 22 12 22C17.5136 22 22 17.5145 22 12C22 6.48636 17.5136 2 12 2ZM9.6868 8.28934L12.0002 10.6028L14.3136 8.28946C14.6994 7.90366 15.3249 7.90366 15.7107 8.28946C16.0964 8.67525 16.0964 9.30074 15.7107 9.68653L13.3973 11.9999L15.711 14.3136C16.0968 14.6994 16.0968 15.3249 15.711 15.7107C15.3252 16.0964 14.6997 16.0964 14.314 15.7107L12.0002 13.3969L9.68642 15.7108C9.30063 16.0966 8.67514 16.0966 8.28934 15.7108C7.90355 15.325 7.90355 14.6995 8.28934 14.3137L10.6032 11.9999L8.28972 9.68642C7.90393 9.30063 7.90393 8.67514 8.28972 8.28934C8.67552 7.90355 9.30101 7.90355 9.6868 8.28934Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-close-filled",
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48636 6.48636 2 12 2C17.5136 2 22 6.48636 22 12C22 17.5145 17.5136 22 12 22C6.48636 22 2 17.5145 2 12ZM9.68656 8.28934L12 10.6028L14.3133 8.28946C14.6991 7.90366 15.3246 7.90366 15.7104 8.28946C16.0962 8.67525 16.0962 9.30074 15.7104 9.68653L13.3971 11.9999L15.7108 14.3136C16.0966 14.6994 16.0966 15.3249 15.7108 15.7107C15.325 16.0964 14.6995 16.0964 14.3137 15.7107L12 13.3969L9.68618 15.7108C9.30039 16.0966 8.67489 16.0966 8.2891 15.7108C7.90331 15.325 7.90331 14.6995 8.2891 14.3137L10.6029 11.9999L8.28948 9.68642C7.90369 9.30063 7.90369 8.67514 8.28948 8.28934C8.67527 7.90355 9.30076 7.90355 9.68656 8.28934Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRounded);
export default __webpack_public_path__ + "static/media/icon-close-rounded.8ffb2360.svg";
export { ForwardRef as ReactComponent };